import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Renders chat message content as Markdown — tables, code blocks, lists, links, bold/
 * italic (`remark-gfm` adds GitHub-flavored tables/strikethrough/task lists on top of
 * the CommonMark base). Renders straight to React elements, never
 * `dangerouslySetInnerHTML` — no `rehype-raw`, so embedded HTML in a message is shown
 * as literal text, not executed. Safe by construction for LLM/tool-generated content,
 * not just sanitized after the fact.
 */
const COMPONENTS = {
  a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" className="underline" />,
  code: ({ inline, className, children, ...props }) => (
    inline
      ? <code className="px-1 py-0.5 rounded bg-black/10 text-[0.85em]" {...props}>{children}</code>
      : (
        <pre className="rounded-md bg-black/10 p-2 overflow-x-auto my-1">
          <code className={className} {...props}>{children}</code>
        </pre>
      )
  ),
  table: (props) => (
    <div className="overflow-x-auto my-1">
      <table className="border-collapse text-sm" {...props} />
    </div>
  ),
  th: (props) => <th className="border border-current/20 px-2 py-1 text-left" {...props} />,
  td: (props) => <td className="border border-current/20 px-2 py-1" {...props} />,
  ul: (props) => <ul className="list-disc pl-5" {...props} />,
  ol: (props) => <ol className="list-decimal pl-5" {...props} />,
  p: (props) => <p className="my-1 first:mt-0 last:mb-0" {...props} />,
};

export default function MarkdownContent({ content }) {
  return (
    <div className="text-sm leading-normal">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>{content || ''}</ReactMarkdown>
    </div>
  );
}
